var FuseMaterialColorPickerModule = /** @class */ (function () {
    function FuseMaterialColorPickerModule() {
    }
    return FuseMaterialColorPickerModule;
}());
export { FuseMaterialColorPickerModule };
